import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../colors';

interface IProps extends React.SVGProps<SVGSVGElement> {
    open: boolean;
    size?: string;
    ref?: ((instance: SVGSVGElement) => void) | React.RefObject<SVGSVGElement>;
}

interface ISvg {
    $size: string;
}

const Svg = styled.svg<ISvg>`
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
    line {
        stroke: ${colors.text};
        stroke-width: 20;
        stroke-linecap: round;
    }
`;

function PlusMinus({ open, size, ...props }: IProps): JSX.Element {
    return <Svg viewBox='0 0 100 100' $size={size || '1.5rem'} {...props}>
        <line x1='10' x2='90' y1='50' y2='50' />
        {!open && (<line y1='10' y2='90' x1='50' x2='50' />)}
    </Svg>;
}

export default PlusMinus;
